module.exports = __webpack_public_path__ + "static/media/logo.5e293a91.svg";